import Vue from 'vue';

import { 事業所Api, 事業所Response } from '@/openapi/user';

import StorageDao, { 事業所 } from '@/classes/common/StorageDao';
import UserApiUtility from '@/classes/common/UserApiUtility';
import AbstractデータService from '@/classes/service/AbstractデータService';

type State = {
  事業所: 事業所 | null;
};

const state = Vue.observable<State>({
  事業所: null,
});

export default Vue.extend({
  name: 'M事業所Mixin',

  computed: {
    事業所(): 事業所 {
      if (state.事業所 === null) {
        const storaged = StorageDao.get事業所();
        state.事業所 = storaged;
      }
      return state.事業所;
    },
  },

  methods: {
    async set事業所(pk: number): Promise<void> {
      const 事業所Response = await this.update事業所MenuLog(pk);
      const 事業所 = {
        pk,
        ...事業所Response,
      };
      AbstractデータService.set事業所 = 事業所;
      StorageDao.save事業所(事業所);
      state.事業所 = 事業所;
    },
    async update事業所MenuLog(pk?: number): Promise<事業所Response> {
      const response = await UserApiUtility.ogApi(事業所Api).update事業所MenuLog(
        pk === undefined ? this.事業所.pk : pk
      );
      return response.data;
    },
  },
});
